import * as React from 'react';
import { headingSectionNameContext } from './context';
export function HeadingSectionNameProvider(props) {
    var name = props.name, children = props.children;
    return (React.createElement(headingSectionNameContext.Provider, { value: name }, children));
}
